namespace appn.views.tasks.map {

    class InitArgs {
        userGroups: Array<SelectListItem> = [];
        users: Array<AppnSelectListItem> = [];
        userLatLng: string = emptyString;
        userHasDataEntryAccess: boolean = false;
        dateFilter: string = emptyString;
        tasksEdit: string = emptyString;
        tasksMap: string = emptyString;
        tasksMapData: string = emptyString;
        taskRecurringEdit: string = emptyString;
        taskIndex: string = emptyString;
    }

    let _initArgs: InitArgs;
    let _pagingToolbar: any;
    let _mapInDialog: any;
    let _mapMain: any;
    let _topPopupContent: string = emptyString;
    let _isTop: boolean = true; 

    export function init(args: InitArgs): void {
        _initArgs = args;

        createPagingToolbar();
        createMapInDialog();
        createMapMain();
        addEvents();
    }

    appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function(channel: string, data: any) {
        if (!_mapMain || !_mapMain.map)
            return;

        (_mapMain.map as L.Map).invalidateSize();
    });

    function addEvents() {
        appn.dialog.showLoading();

        appn.dateFilter.init(_initArgs.dateFilter);

        $('#clearParentTask').on('click', function(e: Event) {
            appn.location.navTo(_initArgs.tasksMap);
        });

        if ($('#ParentTaskId').val() !== undefined)
            $(document).on('click', '.btn-resetFilters', function(e: Event) {
                appn.location.navTo(_initArgs.tasksMap);
            });

        appn.taskTemplateFilter.init();

        //  Get auto generate color classes
        _mapMain.usersColorClasses = [];
        $('.users-legend ul li').each(function(i: number, item: HTMLElement) {
            const colorClasses = $(item)?.attr('class')?.split(' ') ?? [];

            colorClasses.forEach(function(colorClass: string, index: number): void {
                if (colorClass.contains('color-brand-'))
                    _mapMain.usersColorClasses.push({ userId: $(item).prop('id'), colorClass: colorClass });
            });
        });

        _mapMain.templateTypesColorClasses = [];
        $('.template-type-legend ul li').each(function(i: number, item: HTMLElement) {
            const colorClasses = $(item)?.attr('class')?.split(' ') ?? [];

            for (let ix = 0; ix < colorClasses.length; ix++)
                if (colorClasses[ix].indexOf('color-brand-') !== -1) {
                    _mapMain.templateTypesColorClasses.push({ name: $(item).prop('id'), colorClass: colorClasses[ix] });
                    break;
                }
        });

        _mapMain.setColorBy(appn.emptyString);

        $('#ColorByStatus,#ColorByUser,#ColorByTemplateType').off().on('change', function() {
            const id = $(this).prop('id');

            if (id === 'ColorByStatus')
                _mapMain.setColorBy('statuses');

            if (id === 'ColorByUser')
                _mapMain.setColorBy('users');

            if (id === 'ColorByTemplateType')
                _mapMain.setColorBy('templateTypes');

            _mapMain.getMapDataFromServer(true);
        });

        _mapMain.initmap();
        _pagingToolbar.init();
        _mapMain.getMapDataFromServer(true);
    }

    function createPagingToolbar(): void {
        _pagingToolbar = {
            init: function() {
                $('#GoPrevious').on('click', function() {
                    if (!appn.ui.isElementDisabled($('#GoPrevious'))) {
                        _pagingToolbar.pageNum--;
                        _mapMain.getMapDataFromServer();
                    }
                });
                $('#GoNext').on('click', function() {
                    if (!appn.ui.isElementDisabled($('#GoNext'))) {
                        _pagingToolbar.pageNum++;
                        _mapMain.getMapDataFromServer();
                    }
                });
            },
            pageSize: 100,
            pageNum: 1,
            totalRecords: 0,
            updateUi: function(data: any) {
                _pagingToolbar.totalRecords = data.TotalRecords;
                _pagingToolbar.totalWithoutLocation = data.TotalWithoutLocation;

                let totalText = T('No results found');

                if (_pagingToolbar.totalRecords > 100) {
                    const totalRecs = _pagingToolbar.totalRecords;
                    const startRec = ((_pagingToolbar.pageSize * _pagingToolbar.pageNum) - _pagingToolbar.pageSize) + 1;
                    const lastRec = Math.min((_pagingToolbar.pageSize * _pagingToolbar.pageNum), totalRecs);

                    totalText = T('Showing {0} to {1} of {2} Tasks', startRec, lastRec, totalRecs);
                    $('.pagingToolbarTaskMap-inner').show();
                }
                else
                    $('.pagingToolbarTaskMap-inner').hide();

                $('#TotalsText').html(`${totalText} <i class="fa fa-question-circle" title="The map displays 100 pins at a time when a location is set."></i>`);

                if ((_pagingToolbar.pageSize * _pagingToolbar.pageNum) < _pagingToolbar.totalRecords)
                    appn.ui.enableElement($('#GoNext'));
                else
                    appn.ui.disableElement($('#GoNext'));

                if (_pagingToolbar.pageNum > 1)
                    appn.ui.enableElement($('#GoPrevious'));
                else
                    appn.ui.disableElement($('#GoPrevious'));

            }
        };
    }

    function createMapInDialog(): void {
        _mapInDialog = {
            map: {},
            currentLatLon: {},
            marker: {},
            initmap: function(lat: number, lon: number) {
                const savedLat = lat;
                if (savedLat !== 0) {
                    _mapInDialog.map = appn.ui.mapInit('mapInDialog', 0, 0, 11, false);
                    _mapInDialog.currentLatLon = new L.LatLng(savedLat, lon);
                    _mapInDialog.initMarker();
                    _mapInDialog.map.setView(_mapInDialog.currentLatLon, 15);
                }
            },
            initMarker: function() {
                const icon = L.divIcon({
                    html: '<div class="appn-mapPin"></div><div class="appn-mapShadow"></div>'
                });
                _mapInDialog.marker = new L.Marker(_mapInDialog.currentLatLon, { draggable: false, icon: icon });
                _mapInDialog.map.addLayer(_mapInDialog.marker);
            }
        };
    }

    function createMapMain(): void {
        _mapMain = {
            map: {},
            markersAdded: [],
            resultsWithoutGps: [],
            totalEntries: 0,
            totalWithoutLocation: 0,
            firstPopup: null,
            firstEntryLatLng: null,
            tasksToRender: [],
            usersColorClasses: [],
            templateTypesColorClasses: [],
            updateTotalEntries: function() {
                _mapMain.totalEntries = _pagingToolbar.totalRecords + _pagingToolbar.totalWithoutLocation;

                let totalText = '<i class="fa fa-search text-danger"></i><span class="ml-2">' + T('No results found') + '</span>';
                if (_mapMain.totalEntries > 0)
                    totalText = T('<b>{0}</b> Tasks', _mapMain.totalEntries);

                const currentDateSelection = $('.appnDateFilter li.active .appnDateFilter-typeName').text();
                totalText += T(' for {0}', currentDateSelection.toLowerCase());
                $('.header-text .totalShowing').html(totalText);
            },
            updateNoLatLongEntries: function() {
                if (_pagingToolbar.totalWithoutLocation > 0) {
                    //  Status Filter
                    const statusToFilterBy = appn.dataTable.getStateOrDefault('statusFilter', $('#statusFilter').val());
                    if (!statusToFilterBy.value || statusToFilterBy.value === 'All')
                        statusToFilterBy.value = appn.emptyString;

                    //  User Filter
                    const userToFilterBy = appn.dataTable.getStateOrDefault('userFilter', $('#userFilter').val());
                    if (!userToFilterBy.value || userToFilterBy.value === 'All')
                        userToFilterBy.value = appn.emptyString;

                    //  Group Filter
                    const groupToFilterBy = appn.dataTable.getStateOrDefault('userGroupFilter', $('#userGroupFilter').val());
                    if (!groupToFilterBy.value || groupToFilterBy.value === 'All')
                        groupToFilterBy.value = appn.emptyString;

                    //  Date Filter
                    const appnDateFilterValue = appn.dateFilter.getStateOrDefault();

                    let url = appn.location.buildUrl(_initArgs.taskIndex, [
                        { name: 'template', value: appn.taskTemplateFilter.getStateOrDefault().value },
                        { name: 'status', value: statusToFilterBy.value },
                        { name: 'user', value: userToFilterBy.value },
                        { name: 'userGroup', value: groupToFilterBy.value },
                        { name: 'date', value: appnDateFilterValue.type },
                        { name: 'dateFrom', value: encodeURIComponent(appnDateFilterValue.fromDate) },
                        { name: 'dateTo', value: encodeURIComponent(appnDateFilterValue.toDate) },
                        { name: 'parentTaskId', value: $('#ParentTaskId').val() || '' },
                        { name: 'location', value: "ShowWithoutLocation" }
                    ]);

                    let totalText = `<a href="#" id="withoutLocationLink">${T("{0} without location", _pagingToolbar.totalWithoutLocation) }</a>`;
                    $('.header-text .totalNotShowing').html(totalText).show();

                    $('#withoutLocationLink').on('click', function (e: Event) {
                        e.preventDefault();
                        appn.location.navTo(url);
                    });
                }
                else
                    $('.header-text .totalNotShowing').hide();
            },
            removeMarkers: function() {
                //  remove each 'layer' with a marker in it.
                for (let i = 0; i < _mapMain.markersAdded.length; i++)
                    _mapMain.map.removeLayer(_mapMain.markersAdded[i]);

                _mapMain.markersAdded = [];
            },
            initmap: function() {
                _mapMain.map = appn.ui.mapInit('mapMain', 0, 0, 11, false);
            },
            setColorBy: function(colorBy: string) {
                if (colorBy === appn.emptyString) {
                    colorBy = appn.localStorage.getItem('map_defaultColorBy');

                    if (!colorBy)
                        colorBy = 'users';
                }

                appn.localStorage.setItem('map_defaultColorBy', colorBy);

                if (colorBy === 'statuses') {
                    $('#ColorByStatus').prop('checked', true);
                    $('#ColorByUser').prop('checked', false);
                    $('#ColorByTemplateType').prop('checked', false);
                }

                if (colorBy === 'users') {
                    $('#ColorByUser').prop('checked', true);
                    $('#ColorByStatus').prop('checked', false);
                    $('#ColorByTemplateType').prop('checked', false);
                }

                if (colorBy === 'templateTypes') {
                    $('#ColorByTemplateType').prop('checked', true);
                    $('#ColorByStatus').prop('checked', false);
                    $('#ColorByUser').prop('checked', false);
                }
            },
            renderDataOnMap: function(serverResponse: any) {
                createMap_renderDataOnMap(serverResponse);
            },
            showTaskDetailsDialog: function(event: any) {
                createMap_showTaskDetailsDialog(event);
            },
            getMapDataFromServer: function(resetPaging: boolean) {
                createMap_getMapDataFromServer(resetPaging);
            }
        };
    }

    function createMap_renderDataOnMap(serverResponse: any): void {
        const latlng = _initArgs.userLatLng.split(',');
        //  remove the existing markers ready for the new set being drawn
        _mapMain.removeMarkers();
        _mapMain.resultsWithoutGps = [];
        _mapMain.tasksToRender = [];
        _mapMain.firstPopup = null;
        _mapMain.firstEntryLatLng = new L.LatLng((latlng[0] as any), (latlng[1] as any));
        const bounds = new Array<L.LatLng>();

        // --- TASK MAP DATA ITEMS
        for (let i = 0; i < serverResponse.TaskMapDataItems.length; i++) {
            let colorToAdd = appn.emptyString;
            let colorClassToAdd = appn.emptyString;

            if ($('#ColorByStatus').prop('checked'))
                if (!serverResponse.TaskMapDataItems[i].IsTaskRecurring) {
                    //  Grab the default status
                    const status = serverResponse.TaskMapDataItems[i].Status.trim().toLowerCase();
                    let statusToCompare = status;

                    if (serverResponse.TaskMapDataItems[i].CustomStatus)
                        //  We have a custom status -> use this rather
                        statusToCompare = serverResponse.TaskMapDataItems[i].CustomStatus.trim().toLowerCase();

                    //  Loop through the custom status object and find the right color
                    if (statusToCompare)
                        for (let j = 0; j < serverResponse.MergedStatuses.length; j++) {
                            if (!serverResponse.MergedStatuses[j].Color || !serverResponse.MergedStatuses[j].Color.trim())
                                break;

                            //  Valid color exists
                            if (serverResponse.MergedStatuses[j].Value.trim().toLowerCase() === statusToCompare) {
                                colorToAdd = serverResponse.MergedStatuses[j].Color;
                                break;
                            }
                        }

                    const defaultStatusColorsParsed: any = appn.emptyString;
                    if (!colorToAdd)
                        // Set default colors
                        colorToAdd = defaultStatusColorsParsed[serverResponse.TaskMapDataItems[i].Status];
                }

            if ($('#ColorByUser').prop('checked'))
                //  Get user colors
                $(_mapMain.usersColorClasses).each(function(ii: number, item: any) {
                    if (item.userId === serverResponse.TaskMapDataItems[i].AppUserId) {
                        if (item.colorClass)
                            colorClassToAdd = item.colorClass;
                        return false;
                    }
                });

            if ($('#ColorByTemplateType').prop('checked'))
                //  Get user colors
                $(_mapMain.templateTypesColorClasses).each(function(ii: number, item: any) {
                    if (item.name === serverResponse.TaskMapDataItems[i].TemplateName) {
                        colorClassToAdd = item.colorClass;
                        return false;
                    }
                });

            //  Populate the event
            const eventTitle = serverResponse.TaskMapDataItems[i].TaskName;

            _mapMain.tasksToRender.push({
                id: serverResponse.TaskMapDataItems[i].Id,
                parentId: serverResponse.TaskMapDataItems[i].ParentId,
                title: eventTitle,
                start: serverResponse.TaskMapDataItems[i].Start,
                end: serverResponse.TaskMapDataItems[i].End,
                color: colorToAdd,
                colorClass: colorClassToAdd,
                taskType: serverResponse.TaskMapDataItems[i].TemplateName,
                taskStatus: T(serverResponse.TaskMapDataItems[i].Status),
                isRecurring: serverResponse.TaskMapDataItems[i].IsTaskRecurring,
                startBy: serverResponse.TaskMapDataItems[i].StartBy,
                startByTimeAgo: serverResponse.TaskMapDataItems[i].StartByTimeAgo,
                completeBy: serverResponse.TaskMapDataItems[i].CompleteBy,
                completeByTimeAgo: serverResponse.TaskMapDataItems[i].CompleteByTimeAgo,
                templateName: serverResponse.TaskMapDataItems[i].TemplateName,
                additionalInfo: serverResponse.TaskMapDataItems[i].AdditionalInfo,
                recurringTaskName: serverResponse.TaskMapDataItems[i].RecurringTaskName,
                taskRecurringId: serverResponse.TaskMapDataItems[i].TaskRecurringId,
                taskId: serverResponse.TaskMapDataItems[i].TaskId,
                taskName: serverResponse.TaskMapDataItems[i].TaskName,
                completeAtText: serverResponse.TaskMapDataItems[i].CompleteAtText,
                completeAtLat: serverResponse.TaskMapDataItems[i].CompleteAtLat,
                completeAtLon: serverResponse.TaskMapDataItems[i].CompleteAtLon,
                assignedToId: serverResponse.TaskMapDataItems[i].AssignedToId,
                actualCompleteLat: serverResponse.TaskMapDataItems[i].ActualCompleteLat,
                actualCompleteLon: serverResponse.TaskMapDataItems[i].ActualCompleteLon,
                completedTimeAgo: serverResponse.TaskMapDataItems[i].CompletedTimeAgo,
                assignedToName: serverResponse.TaskMapDataItems[i].AssignedTo,
                userColorCode: serverResponse.TaskMapDataItems[i].UserColorCode
            });
        }

        //  --- DRAW MARKER ON MAP
        const markers = L.markerClusterGroup();
        for (let i = 0; i < _mapMain.tasksToRender.length; i++) {
            let lat = _mapMain.tasksToRender[i].completeAtLat;
            let lon = _mapMain.tasksToRender[i].completeAtLon;

            if (_mapMain.tasksToRender[i].taskStatus === 'Completed' && (!lat || lat === 0 || !lon || lon === 0)) {
                //  This means we have a completed task to show but there was no initial location set.
                //  Show this tasks actual Complete rather so its at least visible to the users and not ommited.
                lat = _mapMain.tasksToRender[i].actualCompleteLat;
                lon = _mapMain.tasksToRender[i].actualCompleteLon;
            }

            const newCoordinate = new L.LatLng(lat, lon, 1);
            bounds.push(newCoordinate);

            const pinColourClass = _mapMain.tasksToRender[i].colorClass;
            const pinUserColor = _mapMain.tasksToRender[i].userColorCode;
            let icon;

            if ($('#ColorByStatus').prop('checked')) //  Status is colored by hex colors
                //  Use inline style to color map pin
                icon = L.divIcon({
                    html: `<div class="appn-mapPin" style="background-color:${_mapMain.tasksToRender[i].color}; border-color:${_mapMain.tasksToRender[i].color}; opacity: 0.7;"></div>` +
                        `<div class="appn-mapShadow ${pinColourClass}"></div>`,
                    className: 'dummy'
                });
            else 
                if (!$('#ColorByTemplateType').prop('checked') && pinUserColor)
                    //  Use user background color to color map pin
                    icon = L.divIcon({
                        html: `<div class="appn-mapPin" style="background-color:${pinUserColor}; border-color:${pinUserColor};"></div><div class="appn-mapShadow" style="background-color:${pinUserColor}; border-color:${pinUserColor};"></div>`,
                        className: 'dummy'
                    });
                else
                    //  Use class to color map pin
                    icon = L.divIcon({
                        html: `<div class="appn-mapPin ${pinColourClass}"></div><div class="appn-mapShadow ${pinColourClass}"></div>`,
                        className: 'dummy'
                    });

            //  Create marker and add layers
            const newMarker = new L.Marker(newCoordinate, { icon: icon });
            markers.addLayer(newMarker);

            let buttons = appn.emptyString;

            if (_initArgs.userHasDataEntryAccess)
                buttons = `<br /><button class="btn btn-link btn-sm pb-0 btn-task-viewDetails">${T('View Details')}</button>`;

            if (_mapMain.tasksToRender[i].parentId === _mapMain.tasksToRender[i].id && !window.location.href.contains(_mapMain.tasksToRender[i].parentId))
                buttons += `<a href="${_initArgs.tasksMap}?parentTaskId=${_mapMain.tasksToRender[i].parentId}" class="btn btn-link btn-sm pb-0">${T('Show Children')}</a>`;

            if (buttons.hasValue())
                buttons += '<br />';

            const popupText = `<div class="appnMapPopup" data-taskid="${_mapMain.tasksToRender[i].id}">` +
                `<h5>${_mapMain.tasksToRender[i].title}</h5><span>${T('Start by {0}', _mapMain.tasksToRender[i].startBy)}</span><br />` +
                `${_mapMain.tasksToRender[i].assignedToName}<br />` +
                `<span>${_mapMain.tasksToRender[i].taskStatus}</span>` +
                `${buttons}` +
                `<span class="text-muted leaflet-popup-gpsstring"><i class="fa fa-map-marker"></i> ${lat} ${lon}</span></div>`;

            const popup = newMarker.bindPopup(popupText).on('popupopen', function (popup: L.LeafletEvent) {
                // Compare to top popup
                _isTop = (popup as any).popup._content === _topPopupContent;
                // Show more detail
                $('.btn-task-viewDetails').on('click', function(this: HTMLElement, e: Event) {
                    const taskId = $(this).closest('.appnMapPopup').data('taskid');

                    $.each(_mapMain.tasksToRender, function(index: string | number, task: any) {
                        if (task.id === taskId) {
                            _mapMain.showTaskDetailsDialog(task);
                            return false;
                        }
                    });

                });

                ($('abbr.timeago') as any).timeago();
            });

            if (!_mapMain.firstPopup) {
                _mapMain.firstPopup = popup;
                _topPopupContent = _mapMain.firstPopup._popup._content;
                _mapMain.firstEntryLatLng = newCoordinate;
            }
        }

        _mapMain.markersAdded.push(markers);
        _mapMain.map.addLayer(markers);
        _mapMain.updateTotalEntries();
        _mapMain.updateNoLatLongEntries();

        if (_mapMain.firstPopup)
            _mapMain.firstPopup.openPopup();

        if (bounds.length > 0)
            _mapMain.map.fitBounds(bounds);
        else
            _mapMain.map.setView(_mapMain.firstEntryLatLng, 6);

    }

    function createMap_showTaskDetailsDialog(event: any): void {
        if (event.isRecurring) {
            const buttonConfig: { [k: string]: any } = {};
            buttonConfig.schedule = {
                label: T('Schedule'),
                className: 'btn-info',
                callback: function() {
                    appn.location.navTo(`${_initArgs.taskRecurringEdit}/${event.id}`, [
                        {
                            name: 'bk',
                            value: 'Calendar_Tasks'
                        }
                    ]);
                    return true;
                }
            };

            buttonConfig.details = {
                label: '<span>' + T('Details') + '</span>',
                className: 'btn-success',
                callback: function() {
                    appn.location.navTo(_initArgs.tasksEdit, [
                        { name: 'taskRecurringId', value: event.id },
                        { name: 'bk', value: 'Calendar_Tasks' }
                    ]);
                    return true;
                }
            };

            const modalContent = `<div><div class="form-group">` +
                `<label class="col-form-label col-sm-4">${T('Recurring Task')}</label>` +
                `<div class="col-sm-8">` +
                `<label class="col-form-label">${event.recurringTaskName}</label>` +
                `</div></div>` +
                `<div class="form-group ${event.templateName ? '' : 'hide'}">` +
                `<label class="col-form-label col-sm-4">${T('Template')}</label>` +
                `<div class="col-sm-8">` +
                `<label class="col-form-label">${event.templateName}</label>` +
                `</div></div>` +
                `<div class="form-group">` +
                `<label class="col-form-label col-sm-4">${T('Start By')}</label>` +
                `<label class="col-form-label col-sm-8">${event.startBy}</label>` +
                `<label class="col-form-label col-sm-4">${T('Complete By')}</label>` +
                `<label class="col-form-label col-sm-8">${event.completeBy}</label>` +
                `</div>` +
                `<div class="form-group ${event.allDay ? '' : 'hide'}">` +
                `<label class="col-form-label col-sm-4">${T('All Day')}</label>` +
                `<div class="col-sm-8">` +
                `<label class="col-form-label"><i class="fa fa-check"></i></label>` +
                `</div></div>` +
                `<div class="form-group ${event.additionalInfo ? '' : 'hide'}">` +
                `<label class="col-form-label col-sm-4">${T('Additional Info')}</label>` +
                `<div class="col-sm-5">` +
                `<label class="col-form-label">${event.additionalInfo}</label>` +
                `</div></div></div>`;

            appn.dialog.custom({
                message: modalContent,
                title: `${event.title}`,
                modalColor: 'modal-info',
                closeButton: true,
                buttons: buttonConfig
            });

        } else {
            let recurId = '';
            if (event.isRecurring)
                recurId = event.taskRecurringId;

            const queryString = appn.location.buildQueryString([
                { name: 'id', value: event.id },
                { name: 'taskRecurringId', value: recurId },
                { name: 'isLoadingIframe', value: 'true' },
                { name: 'returnAction', value: 'Map' }
            ]);

            appn.iframe.openModal({
                url: `${_initArgs.tasksEdit}/${queryString}`,
                size: 'modal-xl'
            }).then(function(modal: JQuery<HTMLElement>) {
                modal.on('hidden.bs.modal', function() {
                    appn.location.reloadCurrentPage();
                });

                addItemEvents(event, modal);
            });
        }
    }

    function createMap_getMapDataFromServer(resetPaging: boolean): void {
        appn.dialog.showLoading();

        // *** BUILD URL INC. FILTERS ***
        if (resetPaging)
            _pagingToolbar.pageNum = 1;

        //  Status Filter
        const statusToFilterBy = appn.dataTable.getStateOrDefault('statusFilter', $('#statusFilter').val());
        if (!statusToFilterBy.value || statusToFilterBy.value === 'All')
            statusToFilterBy.value = appn.emptyString;

        //  User Filter
        const userToFilterBy = appn.dataTable.getStateOrDefault('userFilter', $('#userFilter').val());
        if (!userToFilterBy.value || userToFilterBy.value === 'All')
            userToFilterBy.value = appn.emptyString;

        //  Date Filter
        const appnDateFilterValue = appn.dateFilter.getStateOrDefault();

        // Build full URL
        const params = appn.location.buildQueryString([
            { name: 'v', value: new Date().getTime() },
            { name: 'templateId', value: appn.taskTemplateFilter.getStateOrDefault().value },
            { name: 'statusFilter', value: statusToFilterBy.value },
            { name: 'userFilterId', value: userToFilterBy.value },
            { name: 'dateFilter', value: appnDateFilterValue.type },
            { name: 'dateFilterFrom', value: encodeURIComponent(appnDateFilterValue.fromDate) },
            { name: 'dateFilterTo', value: encodeURIComponent(appnDateFilterValue.toDate) },
            { name: 'pageSize', value: _pagingToolbar.pageSize },
            { name: 'pageNum', value: (_pagingToolbar.pageNum - 1) },
            { name: 'parentTaskId', value: $('#ParentTaskId').val() || '' }
        ]);

        // User Group Filter - Only added if userGroups contain values
        let userGroupFilterParam = appn.emptyString;
        if (_initArgs.userGroups.length > 0) {
            const userGroupToFilterBy = appn.dataTable.getStateOrDefault('userGroupFilter', $('#userGroupFilter').val());

            if (!userGroupToFilterBy.value || userGroupToFilterBy.value === 'All')
                userGroupToFilterBy.value = appn.emptyString;

            userGroupFilterParam = `&userGroupFilterId=${userGroupToFilterBy.value}`;
        }

        const url = _initArgs.tasksMapData + params + userGroupFilterParam;

        appn.ajax.post({
            url: url,
            dataType: 'json',
            done: function(data: any): void {
                getMapDataFromServer_AjaxPost_Done(data);
            },
            fail: function(): void {
                // function(p1, p2, p3)
                appn.dialog.alert({
                    modalColor: 'modal-danger',
                    title: T('Map Data Load Failed'),
                    message: T('Failed to load map data. Please sign out and sign in again. Contact support if this problem persists.'),
                    buttons: {
                        ok: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    autoHeaderIcon: false
                });
                appn.dialog.hideLoading();
            }
        });
    }

    function getMapDataFromServer_AjaxPost_Done(data: any) {
        _mapMain.renderDataOnMap(data);
        _pagingToolbar.updateUi(data);

        // Clear all filters
        $('.mapHeader .header-filters').html(emptyString);

        // Append filter button
        appn.sideFilterAndContent.appendShowButton($('.mapHeader .header-filters'));

        // Update statuses box
        $('.mapHeader .header-filters ').prepend(appn.elementBuilder.buildTaskStatusSelect(data.MergedStatuses, 'statusFilter', 'saveMeState'));

        // Update UI with new user box
        $('.mapHeader .header-filters ').prepend(appn.elementBuilder.buildSelect(_initArgs.users, 'userFilter', 'saveMeState select2-noinit'));

        // Update user groups box
        if (_initArgs.userGroups.length > 0)
            $('.mapHeader .header-filters ').prepend(appn.elementBuilder.buildSelect(_initArgs.userGroups, 'userGroupFilter', 'saveMeState'));

        // Status Legend - Update colors and statuses
        $('.statuses-legend ul li').remove();
        let statusesToAddLegend = appn.emptyString;
        for (let i = 0; i < data.MergedStatuses.length; i++)
            statusesToAddLegend += `<li style="background-color:${data.MergedStatuses[i].Color};" role="presentation" class="folder " id="${data.MergedStatuses[i].Value}">` +
                `<span class="text-whitesmoke" id="">${data.MergedStatuses[i].Display}</span></li>`;
        $('.statuses-legend ul').append(statusesToAddLegend);

        appn.saveMeState.init(function() {
            _mapMain.getMapDataFromServer(true);
        },
            function() {
                _mapMain.setColorBy('users');
                _mapMain.getMapDataFromServer(true);
            }, '.mapHeader .header-filters ');

        _mapMain.updateTotalEntries();
        _mapMain.updateNoLatLongEntries();

        // Only display most recent button when there are result with GPS
        if ((data.TaskMapDataItems.length - _mapMain.resultsWithoutGps.length) > 0) {
            // Show Most Recent
            $('.header-filters').prepend(`<button id="btnShowMostRecent" title="${T('Displays the popup for the most recent Task Map Pin.')}" class="btn-sm btn btn-info">${T('Latest')}</button>`);

            $('#btnShowMostRecent').off().on('click', function(e: Event) {
                e.preventDefault();
                const shake = _isTop;
                const bounds = _mapMain.map.getBounds();
                const target = _mapMain.firstEntryLatLng;
                const isTargetInView = target.lat >= bounds._southWest.lat && target.lat <= bounds._northEast.lat && target.lng >= bounds._southWest.lng && target.lng <= bounds._northEast.lng;
                if (!isTargetInView)
                    _mapMain.map.setView(target);
                
                _mapMain.firstPopup.openPopup();

                if (shake)
                    appn.utils.shake($((_mapMain.firstPopup as any)._popup._wrapper));
                    
                ($('abbr.timeago') as any).timeago();
            });
        }

        appn.actionButtons.renderNavbarActionButtons([
            {
                buttonId: 'addnew',
                buttonType: 'AddNew'
            }
        ], appn.requestUser.isUserOrHigher);

        $('#addnew').off().on('click', function(e: Event) {
            e.preventDefault();
            appn.tasks.showAddNewDialog(false, false, undefined, undefined, false, T('Map'));
        });

        select.init();
        tooltip.init();

        select.init({ selector: '#userFilter', minimumResultsForSearch: '25' }); // Start displaying 'search' at 25 items

        // Finished processing -> remove modal
        appn.dialog.hideLoading();
    }

    function addItemEvents(event: any, modal: JQuery<HTMLElement>) {
        $(modal).on('click', 'button[value="Details"]', function(e) {
            e.preventDefault();
            const isrecur = event.isRecurring;

            if (isrecur)
                appn.location.navTo(_initArgs.tasksEdit, [
                    { name: 'taskRecurringId', value: event.taskRecurringId },
                    { name: 'returnAction', value: 'Map' }
                ]);
            else
                appn.location.navTo(_initArgs.tasksEdit, [
                    { name: 'id', value: event.id },
                    { name: 'returnAction', value: 'Map' }
                ]);
        });

        $(modal).on('click', 'button[value="Schedule"]', function(e) {
            e.preventDefault();
            appn.location.navTo(_initArgs.taskRecurringEdit, [
                { name: 'id', value: event.taskRecurringId },
                { name: 'returnAction', value: 'Map' }
            ]);
        });

        $(modal).on('click', 'button[value="Children"]', function(e) {
            e.preventDefault();
            appn.location.navTo(_initArgs.tasksMap, [
                {
                    name: 'parentTaskId',
                    value: event.parentId
                }
            ]);
        });

    }
}
